import { AxiosResponse } from "axios";

import { BaseAuthorizedRequest } from "visible-ui";
import { Survey } from "../../model/survey";


export default class UpdateSurveyRequest extends BaseAuthorizedRequest<
  Survey,
  Survey
> {
  constructor(accessToken: string, submitted: boolean) {
    super(
      "PATCH",
      "/",
      {
        payload: {
          submitted: submitted,
        },
      },
      accessToken
    );
  }

  processResponse(response: AxiosResponse<Survey>): Survey {
    let result = response.data;
    return result;
  }
}
